import { ModelCommon } from '../ModelCommon'
import { ValidBusinessObject } from '../../types'

export type RawScore = {
  name: string
  entityAttributeKey: string // Needs to match the name of a reading from a payload definition (?)
  periodHrs: number // Number? Needs to somehow describe the amount of time to take readings from
  slopeAbove: number
  powerAbove: number
  slopeBelow: number
  powerBelow: number
  threshold: number // If a number calculated with power and threshold is above this level, then score = number - threshold / threshold
}

export type CompositeScorePart = {
  scoreName: string
  weight: number
}

export type CompositeScore = { name: string; operator: 'add' | 'multiply'; parts: CompositeScorePart[] }

export type ScoreSetType = {
  name: string
  supportedType: string
  raw: RawScore[]
  composite: CompositeScore[]
}

const typeName = 'ScoreSet'

class ScoreSet extends ModelCommon {
  raw: RawScore[]
  composite: CompositeScore[]
  name: string
  supportedType: string

  constructor(vob?: ScoreSetType) {
    super(typeName, vob ?? {})

    this.name = vob?.name ?? typeName
    this.supportedType = vob?.supportedType ?? ''

    this.raw = JSON.parse(JSON.stringify(vob?.raw ?? []))
    this.composite = JSON.parse(JSON.stringify(vob?.composite ?? []))
  }
}

export { ScoreSet }
